var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "sep"
  }), _c('div', {
    staticClass: "wrap-content"
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "color": "#333",
      "margin-bottom": "20px"
    }
  }, [_vm._v(" 請輸入發送至您手機的驗證碼 ")]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyCode,
      expression: "verifyCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "code",
      "name": "code",
      "placeholder": "請輸入驗證碼",
      "pattern": "[0-9]{6}",
      "disabled": _vm.formLoading
    },
    domProps: {
      "value": _vm.verifyCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value;
      }
    }
  })]), _c('div', {
    attrs: {
      "id": "countdown"
    }
  }, [_c('span', {
    attrs: {
      "id": "sec"
    }
  }, [_vm._v(_vm._s(_vm.seconds))]), _c('span', [_vm._v(" 秒後才可重新發送驗證碼")]), _vm.canResend ? _c('h5', {
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    attrs: {
      "id": "resend"
    },
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(" 重新發送驗證碼 ")]) : _vm._e()])]), _c('div', {
    staticClass: "btnwrap fixedbottom",
    attrs: {
      "id": "final"
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/btn_next.png"),
      "alt": "下一步"
    }
  })])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_c('span', {
    staticClass: "title"
  }, [_vm._v("簡訊驗證")])]);
}]

export { render, staticRenderFns }